import { Typography } from '@mui/material'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Plus from 'mdi-material-ui/Plus'
import { useState } from 'react'
import toast from 'react-hot-toast'
import { BsArrowCounterclockwise } from "react-icons/bs"
import { apiService } from '../../api/axiosClient'
import Page from '../../components/Page'
import PageHeader from '../../components/page-header'
import BoxWrapper from '../../styles/BoxWrapper'
import RegisterCategory from '../../views/category/RegisterCategory'
import TableCategory from '../../views/category/TableCategory'

const Category = () => {
  const [reload, setReload] = useState(0)
  const [show, setShow] = useState(false);

  const handleRequest = async () => {
    try {
      const response = await apiService.post('/category/update');
      toast.success('카테고리 업데이트 되었습니다');
      setReload(reload + 1);
    } catch (error) {
      toast.error('카테고리 업데이트가 실패했습니다');
    }
  }

  return (
    <Page title="Category">
      <Grid container spacing={6}>
        <PageHeader
          title={
            <Typography variant='h5' color='#666CFF'>
              상품 카테고리
            </Typography>
          }
          subtitle={
            <Alert severity='info' sx={{mt:2}}>
              해당 필드값을 변경을 원하시면 더블클릭후, 값을 변경후 ENTER 키를 입력하세요. 이후 해당줄을 선택후 업데이트 버튼을 클릭하세요
              카테고리 삭제시, 하위 카테고리가 존재하면 자동으로 하위 항목도 삭제됩니다.
              <br/>
              엑셀파일을 통해 상품등록시, 카테고리를 등록하려면 업데이트 버튼을 통해 자동으로 카테고리가 생성됩니다.
            </Alert>
          }
        />
        <BoxWrapper>
          <Button variant='contained' startIcon={<Plus />} onClick={() => {setShow(true)}} >등록</Button>
          <Button variant='contained' color='warning' startIcon={<BsArrowCounterclockwise />} onClick={handleRequest}>카테고리 업데이트</Button>
        </BoxWrapper>
        <RegisterCategory show={show} setShow={setShow} reload={reload} setReload={setReload} />
        <Grid item xs={12}>
          <TableCategory reload={reload} setReload={setReload}/>
        </Grid>
      </Grid>
    </Page>
  )
}

export default Category